
(() => {
const colors={"natural heather": "#ddd3be", "heather natural": "#ddd3be", "athletic grey": "#aaa", "heather gray": "#aaa", "ice blue": "#c2dce6", "light blue": "#b5d6ec", "light pink": "#f3c6d5", "black/white": "linear-gradient(90deg,#222 0 32%,#fff 32% 68%,#222 68%)", "red/white": "linear-gradient(90deg,#be3038 0 32%,#fff 32% 68%,#be3038 68%)", "pink/white": "linear-gradient(90deg,#e6a7b9 0 32%,#fff 32% 68%,#e6a7b9 68%)", "natural": "#eee5ce", "white": "#fff", "ivory": "#f4eedf", "sand": "#d6c9ae", "dust": "#d4c6b4", "black": "#222", "red": "#be3038", "navy": "#213046", "blue": "#476d9c", "pink": "#e6a7b9", "grey": "#999", "gray": "#999", "green": "#42674c"};
function init(root){
 if(root.dataset.mmReady)return;
 const picker=root.querySelector("variant-picker"),form=root.querySelector(".js-product-form"),buy=form?.querySelector('[name="add"]');
 if(!form||!buy)return;
 root.dataset.mmReady="true";
 const selectors=picker?[...picker.querySelectorAll(".option-selector")]:[];
 const variants=picker?JSON.parse(picker.querySelector('[type="application/json"]').textContent).variants:[];
 const size=selectors.find(s=>/size/i.test(s.dataset.optionName||""));
 let sizeChosen=!size||new URLSearchParams(location.search).has("variant");
 let sizeSelect;
 const selected=s=>s.dataset.selectorType==="dropdown"?s.querySelector(".custom-select__btn").textContent.trim():s.querySelector("input:checked")?.value;
 const sync=(s,value,notify=true)=>{
   const custom=s.querySelector("custom-select");
   if(!custom)return;
   const option=[...custom.querySelectorAll('[role="option"]')].find(o=>o.dataset.value===value);
   if(!option)return;
   custom.querySelectorAll('[aria-selected="true"]').forEach(o=>o.removeAttribute("aria-selected"));
   option.setAttribute("aria-selected","true");
   custom.querySelector(".custom-select__btn span").textContent=value;
   custom.selectedOption=option;
   custom.querySelector('[role="listbox"]').setAttribute("aria-activedescendant",option.id);
   if(notify && size && s!==size){
     const index=selectors.indexOf(size);
     const matching=variants.filter(v=>selectors.every((selector,i)=>i===index||v.options[i]===selected(selector)));
     if(matching.length&&!matching.some(v=>v.options[index]===selected(size))){
       sizeChosen=false;
       sync(size,(matching.find(v=>v.available)||matching[0]).options[index],false);
     }
   }
   if(notify)custom.dispatchEvent(new Event("change",{bubbles:true}));
 };
 const native=(s,values)=>{
   const select=document.createElement("select");
   select.className="mm-native-select";select.style.appearance="auto";
   select.setAttribute("aria-labelledby",s.querySelector(".label").id);
   for(const value of values)select.add(new Option(value,value));
   select.value=selected(s);
   s.querySelector("custom-select").hidden=true;
   s.append(select);
   return select;
 };
 selectors.forEach(s=>{
   const name=s.dataset.optionName.toLowerCase();
   s.dataset.mmKind=/size/.test(name)?"size":s.dataset.mmCombined==="true"?"style":/colou?r/.test(name)?"color":"style";
   if(s.dataset.mmKind==="color" && s.dataset.selectorType==="dropdown"){
     const values=[...s.querySelectorAll('[role="option"]')].map(o=>o.dataset.value).filter(Boolean);
     const select=native(s,values);
     select.addEventListener("change",e=>{e.stopPropagation();sync(s,select.value);});
   }
   if(s.dataset.mmKind==="color"){
     s.querySelectorAll('input[type="radio"]').forEach(input=>{
       const color=colors[input.value.toLowerCase()],label=input.nextElementSibling;
       if(color){label.classList.add("mm-color-swatch");label.classList.remove("opt-label--btn");label.style.setProperty("--mm-color",color);label.style.background=color;label.title=input.value;label.querySelector("span")?.classList.add("visually-hidden");}
       else if(label&&!label.querySelector('img')){label.classList.remove('opt-label--swatch','mm-color-swatch');label.classList.add('opt-label--btn');label.querySelector('span')?.classList.remove('visually-hidden');}
     });
   }
   if(s.dataset.mmKind!=="style"||s.dataset.selectorType!=="dropdown")return;
   const options=[...s.querySelectorAll('[role="option"]')].map(o=>o.dataset.value).filter(Boolean);
   const parsed=options.map(value=>{
     const normalized=value.toLowerCase().replace(/^3\/4 /, "");
     const key=Object.keys(colors).sort((a,b)=>b.length-a.length).find(c=>normalized.startsWith(c+" "));
     return key?{value,color:key.replace(/\b\w/g,c=>c.toUpperCase()),key,style:(value.startsWith("3/4 ")?"3/4 ":"")+value.slice((value.startsWith("3/4 ")?4:0)+key.length+1)}:null;
   });
   if(!parsed.length||parsed.some(v=>!v)){
     const select=native(s,options);
     select.addEventListener("change",e=>{e.stopPropagation();sync(s,select.value);});
     return;
   }
   const current=parsed.find(v=>v.value===selected(s))||parsed[0];
   const styles=[...new Set(parsed.map(v=>v.style))];
   const select=native(s,styles);select.value=current.style;
   const group=document.createElement("fieldset");group.className="mm-color-group";
   const legend=document.createElement("legend");legend.className="label";group.append(legend);
   s.append(group);
   const colorSelect=document.createElement("select");colorSelect.className="mm-native-select";colorSelect.style.appearance="auto";colorSelect.setAttribute("aria-label",root.dataset.colorLabel);group.append(colorSelect);
   let color=current.color;
   const draw=()=>{
     const matching=parsed.filter(v=>v.style===select.value);
     if(!matching.some(v=>v.color===color))color=matching[0].color;
     legend.textContent=root.dataset.colorLabel+": "+color;
     colorSelect.replaceChildren(...matching.map(v=>new Option(v.color,v.color)));colorSelect.value=color;
     return matching.find(v=>v.color===color).value;
   };
   colorSelect.addEventListener("change",e=>{e.stopPropagation();color=colorSelect.value;sync(s,draw());});
   select.addEventListener("change",e=>{e.stopPropagation();sync(s,draw());});draw();
 });
 if(size&&size.dataset.selectorType==="dropdown"){
   sizeSelect=native(size,[]);
   sizeSelect.required=true;
   sizeSelect.setAttribute("aria-required","true");
   const refresh=()=>{
     const index=selectors.indexOf(size);
     const values=[...new Set(variants.filter(v=>selectors.every((s,i)=>i===index||v.options[i]===selected(s))).map(v=>v.options[index]))];
     const prior=sizeSelect.value||selected(size);
     sizeSelect.replaceChildren(new Option(root.dataset.sizePrompt,""));
     values.forEach(value=>sizeSelect.add(new Option(value,value)));
     if(!values.includes(prior))sizeChosen=false;
     sizeSelect.value=sizeChosen?prior:"";
   };
   refresh();
   sizeSelect.addEventListener("change",e=>{e.stopPropagation();sizeChosen=!!sizeSelect.value;if(sizeChosen)sync(size,sizeSelect.value);update();});
   root.addEventListener("on:variant:change",()=>{refresh();update();});
 }
 const bar=document.createElement("div");bar.className="mm-mobile-buy";bar.hidden=true;
 const price=document.createElement("span");price.className="mm-mobile-price";
 const action=document.createElement("button");action.type="button";action.className="mm-mobile-checkout";bar.append(price,action);root.append(bar);
 function update(){
   if(!sizeChosen){if(buy.disabled)buy.disabled=false;if(buy.textContent!=="Add to Cart")buy.textContent="Add to Cart";}
   price.textContent=root.querySelector(".js-product-price .price__current")?.textContent.trim()||"";
   action.textContent=sizeChosen?buy.textContent:"Add to Cart";
   action.disabled=sizeChosen&&buy.disabled;
 }
 const promptForSize=()=>{
   size?.scrollIntoView({behavior:"smooth",block:"center"});
   if(sizeSelect){sizeSelect.focus();sizeSelect.reportValidity();}
   else size?.querySelector("input,button,select")?.focus();
 };
 const guardSize=e=>{
   if(sizeChosen)return;
   e.preventDefault();e.stopImmediatePropagation();promptForSize();
 };
 buy.addEventListener("click",guardSize,true);
 form.addEventListener("submit",guardSize,true);
 action.addEventListener("click",()=>{if(!sizeChosen){promptForSize();}else if(!buy.disabled){form.requestSubmit(buy);}});
 new MutationObserver(update).observe(buy,{attributes:true,childList:true,subtree:true});
 let showing=false;
 const observer=new IntersectionObserver(entries=>{showing=!entries[0].isIntersecting&&entries[0].boundingClientRect.top<0;bar.hidden=!showing;},{threshold:0});observer.observe(buy);
 const review=root.parentElement.querySelector(".jdgm-review-widget")||[...document.querySelectorAll("h2")].find(h=>h.textContent.trim()==="Customer Reviews");
 if(review)review.id="mm-product-reviews";
 update();
}
const boot=()=>document.querySelectorAll("[data-mm-product]").forEach(init);
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",boot);else boot();
document.addEventListener("shopify:section:load",boot);
})();

